import React from "react";
import { Link } from "react-router-dom";
import { Menu, Layout } from "antd";
import { StyledImageHeader } from "styled/common-styled";
import { translate } from "lib/helper";

import { GroupMenu, ListMenu } from "./ListMenu";

const { SubMenu } = Menu;
const { Sider } = Layout;

const SliderBar = (props) => {
  const {
    collapsed,
    profile: { permissions },
  } = props;

  const shouldRenderMenu = (permissions, key) => {
    let cnt = 0;

    if (typeof permissions === "string") {
      permissions = JSON.parse(permissions || "{}")
    }

    permissions.map((name) => {
      let findMenu = ListMenu.find(
        (x) => x.group === key && x.matching_key === name.matching_name
      )

      if (typeof findMenu !== "undefined") {
        if (name.can_view !== 0) {
          return cnt++;
        }
      }
      return cnt;
    });

    return cnt > 0 ? true : false;
  };

  let logoImgStyle = {
    width: "45px"
  }

  if (collapsed === false) {
    logoImgStyle = {
      width: "55px",
      marginLeft: "50px",
      marginTop: "6px"
    }
  }

  return (
    <Sider trigger={null} collapsible collapsed={collapsed}>
      <StyledImageHeader>
        <img
          style={logoImgStyle}
          src="/logo_small.jpg"
          alt=""
        />
      </StyledImageHeader>
      <Menu mode="inline" id="siderbar" defaultSelectedKeys={["1"]}>
        {GroupMenu.map((group, i) => {
          if (group.hasChildren === false) {
            const { title, path } = ListMenu.find(x => x.group === group.key)
            return shouldRenderMenu(permissions, group.key) && (
              <Menu.Item key={title} icon={group.icon}>
                <Link to={path}>{translate(title, "sidebar")}</Link>
              </Menu.Item>
            );
          } else {
            return (
              shouldRenderMenu(permissions, group.key) && (
                <SubMenu
                  key={group.key}
                  icon={group.icon}
                  title={translate(group.title, "sidebar")}
                >
                  {ListMenu.map((menu, i) => {
                    if (menu.group !== group.key) return null;
                    let findMenu = permissions.find(x => x.matching_name === menu.matching_key)
                    if (typeof findMenu === "undefined") return null
                    if (findMenu.can_view === 0) return null

                    return (
                      <Menu.Item key={menu.title}>
                        <Link to={menu.path}>
                          {translate(menu.title, "sidebar")}
                        </Link>
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              )
            );
          }
        })}
      </Menu>
    </Sider>
  );
};

SliderBar.defaultProps = {
  profile: { permissions: [] },
};

export default SliderBar;
